import { render, staticRenderFns } from "./CustomLists.vue?vue&type=template&id=5192e41f&scoped=true&"
import script from "./CustomLists.vue?vue&type=script&lang=js&"
export * from "./CustomLists.vue?vue&type=script&lang=js&"
import style0 from "./CustomLists.vue?vue&type=style&index=0&id=5192e41f&prod&lang=scss&scoped=true&"
import style1 from "./CustomLists.vue?vue&type=style&index=1&id=5192e41f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5192e41f",
  null
  
)

export default component.exports